import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getGQLPatientList, getPatientPopulationsDetails, saveNewUser, getPatientOptionsListWithVitalsData, getGQLPatientDetails, getGQLPatientDetailsForCareTeam } from "../../api/patient";

export const getPatientOptionsList = createAsyncThunk("patients/getPatientOptionsList", async (_, { rejectWithValue, getState }) => {
  try {
    const loggedInUser = getState().auth.user;
    const variables = loggedInUser.userTypeId == 5 ? {partnerId: loggedInUser.orgId, userCredId: 0 } : {userCredId: loggedInUser.userId, partnerId: 0};
    const response = loggedInUser.userTypeId == 5 ? await getGQLPatientList() : await getPatientOptionsListWithVitalsData(variables);
    return response?.body;
  } catch (error) {
    console.error({ error });
    return rejectWithValue(error);
  }
});

export const getPatientDetails = createAsyncThunk("patients/getPatientDetails", async (variables, { rejectWithValue, getState }) => {
  try {
    const loggedInUser = getState().auth.user;
    const response = loggedInUser.userTypeId == 5 ? await getGQLPatientDetails(variables) : await getGQLPatientDetailsForCareTeam(variables) ;
    return response?.body;
  } catch (error) {
    console.error({ error });
    return rejectWithValue(error);
  }
});

export const editPatient = createAsyncThunk("patients/editPatient", async (data, { rejectWithValue }) => {
  try {
    const response = await saveNewUser(data);
    return JSON.parse(response?.body);
  } catch (error) {
    console.error({ error });
    return rejectWithValue(error);
  }
});


export const getPatientPopulationVitals = createAsyncThunk("patients/getPatientPopulationVitals", async (_, { rejectWithValue, getState }) => {
  try {
    const loggedInUser = getState().auth.user;
    const variables = loggedInUser.userTypeId == 5 ? {partnerId: loggedInUser.orgId, userCredId: 0 } : {userCredId: loggedInUser.userId, partnerId: 0};
    const response = await getPatientPopulationsDetails(variables);
    return response?.body;
  } catch (error) {
    console.error({ error });
    return rejectWithValue(error);
  }
});

export const getPatientList = createAsyncThunk("patients/getPatientList", async (_, { rejectWithValue, getState }) => {
  try {
    const loggedInUser = getState().auth.user;
    const variables = loggedInUser.userTypeId == 5 ? {partnerId: loggedInUser.orgId, userCredId: 0 } : {userCredId: loggedInUser.userId, partnerId: 0};
    const response = await getPatientOptionsListWithVitalsData(variables);
    return response?.body;
  } catch (error) {
    console.error({ error });
    return rejectWithValue(error);
  }
});

const patientSlice = createSlice({
  name: "patient",
  initialState: {
    patientsOptions: null,
    currentPatient: null,
    patientPopulationsVitals: {},
    patientList: [],
    loading: false,
    error: null,
    rowCount: 0
  },
  reducers: {
    resetState: (state) => {
      state.currentPatient = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPatientOptionsList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPatientOptionsList.fulfilled, (state, action) => {
        state.loading = false;
        state.patientsOptions = action.payload?.data;
        state.error = null;
      })
      .addCase(getPatientOptionsList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(editPatient.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(editPatient.fulfilled, (state, action) => {
        state.loading = false;
        state.currentPatient = action.payload;
        state.error = null;
      })
      .addCase(editPatient.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getPatientPopulationVitals.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPatientPopulationVitals.fulfilled, (state, action) => {
        state.loading = false;
        state.patientPopulationsVitals = action.payload?.data && JSON.parse(action.payload?.data);
        state.error = null;
      })
      .addCase(getPatientPopulationVitals.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getPatientList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPatientList.fulfilled, (state, action) => {
        state.loading = false;
        state.rowCount = action.payload?.rowCount;
        state.patientList = action.payload?.data;
        state.patientsOptions = action.payload.data;
        state.error = null;
      })
      .addCase(getPatientList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getPatientDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPatientDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.currentPatient = action.payload?.data;
        state.error = null;
      })
      .addCase(getPatientDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export const { resetState } = patientSlice.actions;
export default patientSlice.reducer;
